import { render, staticRenderFns } from "./lg-brand.vue?vue&type=template&id=140a4cbb"
import script from "./lg-brand.vue?vue&type=script&lang=js"
export * from "./lg-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports